module.exports = __webpack_public_path__ + "img/care2.4ad0a2d8.png";